/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Event_When_TwoInputs */

const en_features_event_when_two = /** @type {(inputs: Features_Event_When_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday 9:00 · North Park`)
};

const pl_features_event_when_two = /** @type {(inputs: Features_Event_When_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedziela 9:00 · Park Północny`)
};

/**
* | output |
* | --- |
* | "Sunday 9:00 · North Park" |
*
* @param {Features_Event_When_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_event_when_two = /** @type {((inputs?: Features_Event_When_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Event_When_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_event_when_two(inputs)
	return en_features_event_when_two(inputs)
});